// extracted by mini-css-extract-plugin
module.exports =  {"tc-list-checkbox":"CellCheckbox-module__tc-list-checkbox___aThnm"};